import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d413dd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icon" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = {
  key: 1,
  class: "button"
}
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = { class: "label" }

import Icon from '@/components/atoms/Icon'
import { computed, ref, withDefaults } from 'vue'

type PropsType = {
  dataTest?: string
  label: string
  icon: string
  hasChild?: boolean
  isChildNavOpen?: boolean
  link?: string
  active?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NavBtn',
  props: {
    dataTest: null,
    label: null,
    icon: null,
    hasChild: { type: Boolean, default: false },
    isChildNavOpen: { type: Boolean, default: false },
    link: { default: '' },
    active: { type: Boolean, default: false }
  },
  emits: ['clickNavBtn'],
  setup(__props: any) {

const props = __props as { dataTest?: string, label: string, icon: string, hasChild: boolean, isChildNavOpen: boolean, link: string, active: boolean };





const iconColor = ref<string>('color-white')

// 開閉用の矢印の向きを変更
const arrowDir = computed<string>(() => (!props.isChildNavOpen ? 'icon_down' : 'icon_up'))

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ active: __props.active })
  }, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clickNavBtn')))
    }, [
      (!__props.hasChild)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: __props.link,
            class: "button",
            "data-test": __props.dataTest
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, [
                _createVNode(_unref(Icon), {
                  type: __props.icon,
                  color: iconColor.value
                }, null, 8, ["type", "color"])
              ]),
              _createElementVNode("span", _hoisted_2, _toDisplayString(__props.label), 1)
            ]),
            _: 1
          }, 8, ["to", "data-test"]))
        : _createCommentVNode("", true),
      (__props.hasChild)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_unref(Icon), {
                type: __props.icon,
                color: iconColor.value
              }, null, 8, ["type", "color"])
            ]),
            _createElementVNode("span", _hoisted_5, _toDisplayString(__props.label), 1),
            _createVNode(_unref(Icon), {
              color: iconColor.value,
              type: "keyboard_arrow_down",
              class: _normalizeClass(["arrow", _unref(arrowDir)])
            }, null, 8, ["color", "class"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})